<template>
  <div class="speakers">
    <div class="container">
      <div class="box">
        <com-h1>优秀出品人</com-h1>
        <com-speakers :speakers="$store.state.speakers"></com-speakers>
      </div>
      <div class="box">
        <com-h1>明星讲师</com-h1>
        <com-speakers :speakers="$store.state.speakers"></com-speakers>
      </div>
    </div>
  </div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import ComSpeakers from 'gkConUI/com-speakers'

export default {
  components: {
    ComH1,
    ComSpeakers
  },
  props: [
    'speakers'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
